import { createSelector } from 'reselect';

import { State } from 'reducers';
import { BudgetAllocationMap } from 'entities/budgetAllocation/reducer';

export const selectBudgetAllocationsState = (state: State): BudgetAllocationMap =>
  state.get('entities').budgetAllocation;

export const selectBudgetAllocations = createSelector(
  selectBudgetAllocationsState,
  (budgetAllocations) => budgetAllocations
);

export const selectActiveBudgetAllocations = createSelector(
  selectBudgetAllocations,
  (budgetAllocations) =>
    budgetAllocations.filter((budgetAllocation) => !!budgetAllocation?.isActive)
);

export const selectBudgetAllocationById = createSelector(
  selectBudgetAllocations,
  (_state, budgetAllocationId) => budgetAllocationId,
  (budgetAllocations, budgetAllocationId) => budgetAllocations.get(budgetAllocationId)
);
